"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DialogTransitionContext: function() {
        return DialogTransitionContext;
    },
    DialogTransitionProvider: function() {
        return DialogTransitionProvider;
    },
    useDialogTransitionContext_unstable: function() {
        return useDialogTransitionContext_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
/**
 * @internal
 */ const defaultContextValue = undefined;
const DialogTransitionContext = /*#__PURE__*/ _react.createContext(undefined);
const DialogTransitionProvider = DialogTransitionContext.Provider;
const useDialogTransitionContext_unstable = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(DialogTransitionContext)) !== null && _React_useContext !== void 0 ? _React_useContext : defaultContextValue;
};
